import {useMappedState} from 'redux-react-hook'
import ApiSdk from 'services/callApi'

function useApiKeyData () {
  const {createApiKey} = ApiSdk.common
  const mapState = state => ({
    apiKey: state?.entities?.apiKey || {}
  })
  return {
    ...useMappedState(mapState),
    createApiKey
  }
}

export default useApiKeyData
